import { autoinject } from 'aurelia-framework';
import isEmpty from 'lodash-es/isEmpty';

import { GenericApi } from '~/api/generic-api';
import { NavigationMenuItem } from '~/components/navigation/navigation-types';
import { FetchUtils } from '~/utils/fetch-utils';
import { Logger } from '~/utils/logger';

@autoinject
export class NavigationAPI extends GenericApi {
	public getURLPrefix() {
		return GenericApi.apiServerURL + 'api/navigation';
	}

	public fetchNavigationViewList(): Promise<string[]> {
		return FetchUtils.getJSON<string[]>(this.getURLPrefix());
	}

	public fetchNavigationViewStructure(
		view: string,
	): Promise<{ name: string; structure: any }> {
		return new Promise<{ name: string; structure: any }>(
			(resolve, reject) => {
				FetchUtils.getJSON<{ name: string; structure: any }>(
					this.getURLPrefix() + `/${view}`,
				)
					.then((data) => {
						!isEmpty(data)
							? resolve({
									name: view,
									structure: data,
							  })
							: reject('No data');
					})
					.catch((reason) => {
						Logger.error(reason);
						reject(reason);
					});
			},
		);
	}
}
